'use client';

import { useEffect } from 'react';

/**
 * Disables the browser's automatic scroll restoration and snaps the page
 * to the top on initial mount. Without this, refreshing the journey leaves
 * the user mid-corridor with a fresh camera/explosion state, producing a
 * desynced visual. Refresh now always means "start over".
 *
 * Mounted in the LocaleLayout so it fires once per cold load. Subsequent
 * client-side navigations don't remount the layout, so legitimate
 * within-session scroll positions stay intact.
 */
export function ScrollResetOnReload() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);
  return null;
}
